import { render, staticRenderFns } from "./CoverImage.vue?vue&type=template&id=67f42cf0&scoped=true"
import script from "./CoverImage.vue?vue&type=script&lang=js"
export * from "./CoverImage.vue?vue&type=script&lang=js"
import style0 from "./CoverImage.vue?vue&type=style&index=0&id=67f42cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f42cf0",
  null
  
)

export default component.exports